var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/_Symbol.js
// module id = 160
// module chunks = 0